module.exports = __webpack_public_path__ + "static/media/car_checklist.e4dda856.svg";